import LocationCrud from './LocationCrud'
export {LocationCrud}
export default LocationCrud
